import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useUserContext } from './../context/user-context'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { isAuthenticated } = useUserContext()
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { from: props.location },
            }}
          />
        )
      }
    />
  )
}

export default PrivateRoute
